import { Box, BoxProps } from '@chakra-ui/react'
import { Text } from 'components'

const TickBox: React.FC<BoxProps> = (props) => {
  return (
    <Box
      bg={'green.500'}
      w={'8'}
      h={'8'}
      rounded={'md'}
      display={'flex'}
      alignItems={'center'}
      justifyContent={'center'}
      {...props}
    >
      <Text fontWeight={'bold'} color={'white'}>
        &#x2713;
      </Text>
    </Box>
  )
}

export default TickBox
